import { render, staticRenderFns } from "./RIMomentoFAST.vue?vue&type=template&id=55bbff0e"
import script from "./RIMomentoFAST.vue?vue&type=script&lang=js"
export * from "./RIMomentoFAST.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports